import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "block mb-3" }
const _hoisted_2 = { class: "font-semibold" }

import { computed, PropType } from 'vue';
import { getRecordType } from '@/common/recordTypes';
import Alert from '@/components/micro/AlertComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import SpfRecordComponent from '@/components/records/SpfRecord.vue';
import { QueryResult, RecordInfo, TXT } from '@/model/Api';

type SpfRecord = {
  record: TXT;
} & RecordInfo


export default /*#__PURE__*/_defineComponent({
  __name: 'SpfRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const recordType = getRecordType('SPF');
const processedRecords = computed(() => props.records.response.answer.filter((item): item is SpfRecord => item.record.recordType === 'TXT' && item.parsedSpf !== undefined));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(processedRecords), (spf, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createElementVNode("span", _hoisted_1, [
          _createTextVNode("This record is valid for "),
          _createVNode(Duration, {
            seconds: spf.record.ttl
          }, null, 8, ["seconds"]),
          _createTextVNode(".")
        ]),
        _createVNode(SpfRecordComponent, {
          domain: __props.domain,
          terms: spf.parsedSpf
        }, null, 8, ["domain", "terms"])
      ], 64))
    }), 128)),
    (!_unref(processedRecords).length)
      ? (_openBlock(), _createBlock(Alert, {
          key: 0,
          type: "warning"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(__props.domain), 1),
              _createTextVNode(" does not have any " + _toDisplayString(_unref(recordType).upper) + " records.", 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})